import { EInstitutionType } from '@ucheba/store/institutions/item/types'

// Точно такая же константа есть в InstitutionExams/constants

export const dictionary = {
  title: {
    [EInstitutionType.University]: 'вуза',
    [EInstitutionType.College]: 'колледжа',
  },
  rates: {
    averageDiplomaAvgScore: {
      title: 'Проходной балл',
      subtitle: 'На бюджет, очно, в среднем за предмет',
    },
    averageBySubjectExamScore: {
      title: 'Проходной балл',
      subtitle: 'На бюджет, очно, в среднем за предмет',
    },
    budgetPlacesCount: {
      title: 'Бюджетные места',
      subtitle: 'Всего в вузе',
    },
    averagePriceBachelor: {
      title: 'Стоимость бакалавриата',
      subtitle: 'И специалитета на очном, за год',
      postfix: ' р.',
    },
    averagePrice: {
      title: 'Стоимость обучения',
      subtitle: 'На очном, за год',
      postfix: ' р.',
    },
    averagePriceMaster: {
      title: 'Стоимость магистратуры',
      subtitle: 'На очном, за год',
      postfix: ' р.',
    },
    countStudents: {
      title: 'Число студентов',
      subtitle: 'Общее количество на всех курсах',
      subtitleCollege: 'Общее количество на всех курсах',
    },
    teachersPerHundredStudents: {
      title: 'Доля преподавателей',
      subtitle: 'В % от общего числа студентов',
    },
    dormitoryCapacity: {
      title: 'Вместимость общежития',
      subtitle: 'Кол-во мест для студентов всех отделений',
    },
    foreignStudentsProportion: {
      title: 'Доля иностранных студентов',
      subtitle: 'В % от общего числа студентов',
    },
  },
}

export const institutionTypeNameLabels = {
  [EInstitutionType.University]: {
    general: 'В вузе',
    allIn: 'Всего в вузе',
  },
  [EInstitutionType.College]: {
    general: 'В колледже',
    allIn: 'Всего в колледже',
  },
  [EInstitutionType.School]: {
    general: 'В школе',
    allIn: 'Всего в школе',
  },
  [EInstitutionType.MBA]: {
    general: 'В MBA',
    allIn: 'Всего в MBA',
  },
  [EInstitutionType.TrainingCenter]: {
    general: 'В учебном центре',
    allIn: 'Всего в учебном центре',
  },
  [EInstitutionType.Kindergarten]: {
    general: 'В детском саду',
    allIn: 'Всего в детском саду',
  },
  [EInstitutionType.ForeignUniversity]: {
    general: 'В зарубежном вузе',
    allIn: 'Всего в зарубежном вузе',
  },
  [EInstitutionType.Agency]: {
    general: 'В агенстве',
    allIn: 'Всего в агенстве',
  },
  [EInstitutionType.ChildrenCourses]: {
    general: 'На детских курсах',
    allIn: 'Всего в детских курсах',
  },
  [EInstitutionType.TrainingCourses]: {
    general: 'На подготовительных курсах',
    allIn: 'Всего в подготовительных курсах',
  },
}

export const FIELDS_WITH_ROUNDED_VALUES = [
  'averagePriceBachelor',
  'averagePriceMaster',
  'averagePrice',
]
